import CoreBase from '../../../services/engines/CoreBase';
import gatewayService from '../../../services/GatewayService';
import responseHelper from '../../../services/ResponseHelper';
import umlPreviewCache from './UmlPreviewCache';

const _name = 'UmlPreviewFetcher';
const TOPIC = 'Jerny.UmlWorkspace'; // same topic as UmlNoteFetcher (UmlSchema notes)
const PAGE_SIZE = 50;

/**
 * Fetches UmlSchemaPreview notes — same TOPIC/paging convention as
 * UmlNoteFetcher, just a different type filter. Writes straight into
 * UmlPreviewCache itself (same style as UmlNoteFetcher/UmlNotesCache).
 */
class UmlPreviewFetcher extends CoreBase {
    fetch = async () => {
        try {
            const previewType = 'UmlSchemaPreview';
            const resp = await gatewayService.getUserEntries(TOPIC, 1, PAGE_SIZE, previewType);
            if (responseHelper.check(resp, '', `${_name}.fetch`) < 0) {
                this.logError('fetch', `code: ${resp?.status}`);
                return [];
            }

            let items = resp.data.items ?? [];
            items = items.filter((x) => x.stateId !== 999 && x.type === previewType);

            umlPreviewCache.setCache(items);
            return items;
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };
}

const umlPreviewFetcher = new UmlPreviewFetcher();
export default umlPreviewFetcher;
